angular.module('app').service('dictionary', ['formatting',function(formatting) {
  this.formatting=formatting;
  var numberIn=formatting.numberIn;
  var amountIn=formatting.amountIn;
  var dateIn=formatting.dateIn;
  this.formatFields={
    'menuitems':{'sort':numberIn},
    'visits':{
    },
    'activities':{'stat':numberIn,'day':dateIn},
    'items':{'quantity':amountIn,'grossunitprice':amountIn,'reductionamount':amountIn,'deltatopay':amountIn},
    'movements':{'amount':amountIn},
    'balances':{'amount':amountIn},
    'promotions':{'amount':amountIn},
    'promotionrestrictions':{},
    'proposals':{'ndays':numberIn,'nday':numberIn},
    'campaigns':{'amount':amountIn},
    'activityvats':{'vatrate':amountIn},
    'meals':{'day':dateIn},
    'ruleintervals':{'startdate':dateIn,'enddate':dateIn},
    'employeecommunications':{'expiry':dateIn}
  };
  this.foreignkeys={
    'visits':{
      'out':{'users':'creator'},
      'in':{'reductions':'visit','activities':'visit','movements':'visit','tickets':'visit',
        'invoices':'visit','invoicerows':'visit','items':'visit','meals':'visit','products':'visit','emails':'visit'}
    },
    'reductions':{
      'out':{'visits':'visit'}
    },
    'activities':{
      'out':{'visits':'visit'},
      'in':{'participants':'activity','activityvats':'activity'}
    },
    'participants':{
      'out':{'activities':'activity','items':'item'}
    },
    'items':{
      'out':{'visits':'visit'},
      'in':{'participants':'item','dishes':'item','products':'item'}
    },
    'movements':{
      'out':{'movements':'counter','accounts':'account','visits':'visit'},
      'in':{'movements':'counter','invoices':'movement'}
    },
    'accounts': {
      'out':{'users':'user'},
      'in':{'movements':'account','balances':'account'}
    },
    'tickets': {
      'out':{'visits':'visit'}
    },
    'balances': {
      'out':{'accounts':'account'}
    },
    'users': {
      'in':{'accounts':'user','visits':'creator','assignments':'user','rights':'user'}
    },
    'invoices': {
      'out': {'visits':'visit','movements':'movement'}
    },
    'invoicerows': {
      'out': {'visits':'visit'}
    },
    'tabs': {
      'in':{'tabstdlines':'tab','tabfreelines':'tab'}
    },
    'tabstdlines':{
      'out':{'tabs':'tab'}
    },
    'tabfreelines':{
      'out':{'tabs':'tab'}
    },
    'rights':{
      'out':{'users':'user'}
    },
    'promotions':{
      'in':{'promotionrestrictions':'promotion'}
    },
    'promotionrestrictions':{
      'out':{'promotions':'promotion'}
    },
    'packets':{
      'in':{'packetcomponents':'packet'}
    },
    'packetcomponents':{
      'out':{'packets':'packet'}
    },
    'weekschedules':{
      'in':{'weekscheduleentries':'weekschedule'}
    },
    'weekscheduleentries':{
      'out':{'weekschedules':'weekschedule'}
    },
    'meals':{
      'out':{'visits':'visit'},
      'in':{'dishes':'meal'}
    },
    'dishes':{
      'out':{'meals':'meal','items':'item'}
    },
    'products':{
      'out':{'visits':'visit','items':'item'}
    },
    'emails':{
      'out':{'visits':'visit'}
    },
    'rulegroups':{
      'in':{'rulemembers':'rulegroup','ruleintervals':'rulegroup'}
    },
    'rulemembers':{
      'out':{'rulegroups':'rulegroup'}
    },
    'ruleintervals':{
      'out':{'rulegroups':'rulegroup'}
    },
    'templates':{
      'in':{'templatesections':'parenttemplate'}
    },
    'templatesections':{
      'in':{'templateelements':'templatesection'},
      'out':{'templates':'parenttemplate'}
    },
    'templateelements':{
      'out':{'templatesections':'templatesection'}
    }
  };
}]);
